import "./StationRecordingRoster.css";

/**
 * Tables and seated players a station camera records together.
 */
export function StationRecordingRoster({
  tables = [],
  t = (k, d) => d || k,
  className = "",
}) {
  return (
    <section
      className={`lt-station-roster${className ? ` ${className}` : ""}`}
      aria-label={t("liveTrainingStationGroupVideo", "Group video")}
    >
      <header className="lt-station-roster__head">
        <p className="lt-station-roster__title">
          {t("liveTrainingStationGroupVideo", "Group video")}
        </p>
        <p className="lt-station-roster__hint">
          {t(
            "liveTrainingStationRosterHint",
            "This camera records every table at the station."
          )}
        </p>
      </header>
      {tables.length ? (
        <ol className="lt-station-roster__list">
          {tables.map((row) => {
            const names = (row.players || [])
              .map((player) => player?.name)
              .filter(Boolean);
            return (
              <li
                key={row.tableId || row.tableNumber}
                className="lt-station-roster__row"
              >
                <span className="lt-station-roster__table">
                  {t("table_with_number", { number: row.tableNumber })}
                </span>
                <span
                  className={`lt-station-roster__players${
                    names.length ? "" : " lt-station-roster__players--empty"
                  }`}
                >
                  {names.length
                    ? names.join(" · ")
                    : t(
                        "liveTrainingStationTableEmpty",
                        "No players seated"
                      )}
                </span>
              </li>
            );
          })}
        </ol>
      ) : (
        <p className="lt-station-roster__empty">
          {t(
            "liveTrainingStationRosterEmpty",
            "No tables at this station yet."
          )}
        </p>
      )}
    </section>
  );
}
